import GoalsSerializer from './base';

export default class State extends GoalsSerializer {}
